import { FC } from 'react';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import classNames from 'classnames';
import { useDetectClickOutside } from 'react-detect-click-outside';

import { getRegion } from '../../helpers/getRegion';
import { getTranslation } from '../../constants/translations';
import { dashboards } from '../../constants/dashboards';

import './Hero.scss';
import { LoginModal } from '../LoginModal/LoginModal';

type Props = {
  isMenuOpened: boolean;
  closeMenu: () => void;
};

const MySwal = withReactContent(Swal);

export const Hero: FC<Props> = ({ isMenuOpened, closeMenu }) => {
  const domen = getRegion();
  const t = getTranslation();
  const ref = useDetectClickOutside({
    onTriggered: closeMenu,
    disableClick: isMenuOpened,
  });

  const scrollToNextBlock = () => {
    const targetBlock = document.getElementById('agenda');
    targetBlock?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  const handleLoginClick = () => {
    if (dashboards.length === 1) {
      window.open(dashboards[0].link);
    } else {
      MySwal.fire({
        html: <LoginModal />,
        showConfirmButton: false,
        width: 'max-content',
      });
    }

    closeMenu();
  };

  return (
    <section className="sixtix__hero hero">
      <article className="hero__device-part">
        <div className="hero__container hero__container--device">
          <img
            src={`./${domen}/devices.png`}
            className="hero__main-img"
            alt="Ddevices"
          />
        </div>
      </article>

      <article className="hero__content-part">
        <div className="_container hero__container hero__container--content">
          <h1 className="hero__title">{t.hero.title}</h1>
          <div className="hero__text-block">
            <p>{t.hero.description}</p>

            <p className="hero__statement">
              <strong>{t.hero.features}</strong>
            </p>
          </div>

          <a
            href={`mailto:info@sixtix.${domen}`}
            className="hero__button button"
          >
            {t.hero.requestDemo}
          </a>
        </div>
      </article>

      <div className="hero__scroll scroll-button">
        <img src="images/scroll_btn.png" alt="" onClick={scrollToNextBlock} />
      </div>

      <div
        className={classNames('hero__burger-menu', {
          'hero__burger-menu--opened': isMenuOpened,
        })}
        id="burger-menu"
        // ref={ref}
      >
        <button
          className="header__button--login button"
          rel="noreferrer"
          onClick={handleLoginClick}
        >
          {t.common.login}
        </button>
        <a
          href={`mailto:info@sixtix.${domen}`}
          className="header__button--lost button"
          target="_blank"
          rel="noreferrer"
          onClick={closeMenu}
        >
          {t.common.lostTicket}
        </a>
      </div>
    </section>
  );
};
